export default __webpack_public_path__ + "static/media/2.39991460.jpg";